var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"source-editor"},[_c('codemirror',{attrs:{"options":_vm.editorOptions},on:{"changes":_vm.sourceChanged},model:{value:(_vm.source2),callback:function ($$v) {_vm.source2=$$v},expression:"source2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }